import { useState } from "react";

export default function FloatingWhatsApp() {
  const [hovered, setHovered] = useState(false);

  const handleClick = () => {
    window.open(
      "https://wa.me/917584050023?text=Hello%20Pandit%20Export%2C%20I%20am%20interested%20in%20your%20products.%20Please%20share%20more%20details.",
      "_blank"
    );
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-2">
      {/* Tooltip label */}
      {hovered && (
        <div className="bg-[#1B4332] text-white text-xs font-semibold px-3 py-2 rounded-lg whitespace-nowrap shadow-lg animate-fade-in">
          Chat with us on WhatsApp
          <div className="absolute bottom-0 right-5 translate-y-full w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-[#1B4332]"></div>
        </div>
      )}

      <button
        onClick={handleClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label="Chat on WhatsApp"
        className="relative w-14 h-14 flex items-center justify-center bg-[#25D366] hover:bg-[#1fbb58] text-white rounded-full shadow-xl cursor-pointer transition-all duration-200 hover:scale-110"
      >
        {/* Pulse rings */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25 pointer-events-none"></span>
        <span className="relative z-10 text-2xl">
          <i className="ri-whatsapp-line"></i>
        </span>
      </button>
    </div>
  );
}
